module.exports = __webpack_public_path__ + "img/background_section5-2.f344fdbd.svg";